import React, { useEffect, useCallback, useState} from 'react';
import FreezeHistory from '../FreezeHistory.js';
import {MULTI_SYNTH, SAMPLED_INSTRUMENT, INSTRUMENT_TYPE_TO_NAME} from 'constants/instrument-types.js';
import Sample from 'repos/Sample.js';
import {SAMPLER, INSTRUMENT, MULTI_FREEZE} from 'constants/track-types.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

const colors = new Colors();

const FrozenTrack = ({track, frozenTrack, frozenTracks, frozenGroup}) => { 
    const {trackData} = frozenTrack;
    let [sample, setSample] = useState(undefined);
    const type = trackData.type;

    useEffect(() => {
        if (trackData.type === SAMPLER) {
            const sampler = Object.keys(trackData.samplers)[0];
            if (sampler) {
                let sample = new Sample(sampler);
                sample.load(false).then(
                    () => {
                        setSample(sample);
                    });
            }
        }
    }, [setSample, frozenTrack]);

    const unfreezeTrack = useCallback(() => {
        track.unfreeze(frozenGroup, frozenTracks, frozenTrack); 
    }, [frozenTrack, frozenTracks, frozenGroup, track]);

    if (type === SAMPLER) {
        if (!sample) {
            return [];
        }
        
        let style = {
            backgroundColor: colors.getColorForHash(sample.getId())
        };
        let thumb = sample.getThumbnail();
        if (thumb && thumb !== "") {
            style.backgroundImage = "url(" + thumb + ")";
        }

        return (
            <div className="frozen-track">
              <div className="frozen-info-container">
                <div
                  onClick={unfreezeTrack}
                  style={style}
                  className="frozen-track-thumbnail"/>
                <div className="frozen-track-name">{sample.name.trim()}</div>
              </div>
            </div>
        );
    } else if (type === INSTRUMENT) {
        const instrumentType = trackData.instrumentType;
        const instrumentName = trackData.presetName ||
              INSTRUMENT_TYPE_TO_NAME[instrumentType];
        let style = {
            backgroundColor: colors.getColorForHash(instrumentName)
        };

        return (
            <div className="frozen-track">
              <div className="frozen-info-container">
                <div
                  onClick={unfreezeTrack}
                  style={style}
                  className="frozen-track-thumbnail"/>
                <div className="frozen-track-name">{instrumentName}</div>
              </div>
            </div>
        );
    } else if (type === MULTI_FREEZE) {
        let name = trackData.presetName || "Multi Freeze";
        let style = {
            backgroundColor: colors.getColorForHash(name)
        };
        if (trackData.presetName) {
            name = trackData.presetName + " (Multi Freeze)";
        }
        return (
            <div className="frozen-track">
              <div className="frozen-info-container">
                <div
                  style={style}
                  className="dot frozen-track-thumbnail"/>
                <div className="frozen-track-name">{trackData.presetName || "Multi Freeze Track"}</div>
              </div>
              <FreezeHistory _track={track} track={trackData}/>
            </div>
        );
    }
    return [];
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FrozenTrack);
